// CuentaPickerXL - Sprint 44 Fase 3 Vista 8.
// Autocomplete de cuentas hoja activas. Tokens + dark.
import { useEffect, useRef, useState } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import * as svc from '../services/contabilidadService';

const CSS_ID = 'xl-cuenta-picker-css';
const CSS = `
.xl-cp { position: relative; font-family: var(--xl-font-sans) }
.xl-cp__input {
  width: 100%;
  font: 400 14px/1.4 var(--xl-font-sans);
  color: var(--xl-color-text);
  background: var(--xl-color-bg);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-md);
  padding: 9px 12px;
  box-sizing: border-box;
}
.xl-cp__input:focus {
  outline: none;
  border-color: var(--xl-color-focus);
  box-shadow: 0 0 0 3px rgba(37,99,235,0.18);
}
[data-xl-theme="dark"] .xl-cp__input:focus {
  box-shadow: 0 0 0 3px rgba(96,165,250,0.28);
}

.xl-cp__menu {
  position: absolute; z-index: 30;
  margin-top: 4px;
  width: 100%;
  background: var(--xl-color-surface);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-md);
  box-shadow: var(--xl-shadow-md);
  max-height: 280px;
  overflow-y: auto;
}
.xl-cp__row {
  display: block; width: 100%;
  text-align: left;
  background: transparent; border: none; cursor: pointer;
  padding: 10px 12px;
  font-family: inherit;
  color: var(--xl-color-text);
}
.xl-cp__row:hover { background: var(--xl-color-surface-alt) }
.xl-cp__row:focus-visible { outline: 2px solid var(--xl-color-focus); outline-offset: -2px }
.xl-cp__code { font-family: var(--xl-font-mono); font-weight: 600; font-size: 13px }
.xl-cp__sub { font-size: 11px; color: var(--xl-color-text-muted); margin-top: 2px }
.xl-cp__hint { padding: 12px; font-size: 12px; color: var(--xl-color-text-muted) }
`;

export default function CuentaPickerXL({ onPick, placeholder = 'Buscar cuenta (codigo o nombre)...' }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const tRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    if (tRef.current) clearTimeout(tRef.current);
    tRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await svc.listCuentas({ solo_hojas: true, activo: 'true', q });
        setItems(res || []);
      } finally { setLoading(false); }
    }, 250);
    return () => { if (tRef.current) clearTimeout(tRef.current); };
  }, [q, open]);

  const pick = (c) => { onPick(c); setQ(''); setOpen(false); };

  return (
    <div className="xl-cp">
      <input type="text" className="xl-cp__input"
        value={q}
        onFocus={() => setOpen(true)}
        onChange={(e) => { setQ(e.target.value); setOpen(true); }}
        placeholder={placeholder} />
      {open && (
        <div className="xl-cp__menu" role="listbox">
          {loading && <div className="xl-cp__hint">Buscando\u2026</div>}
          {!loading && items.length === 0 && <div className="xl-cp__hint">Sin resultados</div>}
          {!loading && items.map((c) => (
            <button key={c.id} type="button" className="xl-cp__row" onClick={() => pick(c)}>
              <div className="xl-cp__code">{c.codigo}</div>
              <div className="xl-cp__sub">{c.nombre} \u00b7 {c.tipo} \u00b7 {c.naturaleza}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
